import { render } from "./Hotspot7.vue?vue&type=template&id=5b33cd31&scoped=true&ts=true"
import script from "./Hotspot7.vue?vue&type=script&lang=ts"
export * from "./Hotspot7.vue?vue&type=script&lang=ts"

import "./Hotspot7.vue?vue&type=style&index=0&id=5b33cd31&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b33cd31"]])

export default __exports__